import React  from "react";
import "../css/footer.scss";
import { useTranslation } from "../contexts/LocaleContext";
import SelectOptionTop from "../Component/SelectOptionTop";

const Footer = ({ isCollapsed }) => { 
  const { t, locale, setLocale } = useTranslation();
  const selectLang = (value) => {
    setLocale(value);
  };

  return (
    <footer
      className={`app-footer ${isCollapsed ? "collapsed" : ""}`}
      role="contentinfo"
      aria-label="Footer"
    >
      <div className="footer-inner">
        <div className="footer-left">{t("footer.copyright")}</div>

        <div className="footer-right">
          <div className="lang-select">
            <SelectOptionTop
              value={locale}
              onChange={(v) => selectLang(v)}
              options={[
                { value: "zh", label: t("lang.chinese") },
                { value: "en", label: t("lang.english") },
              ]}
              ariaLabel="语言选择"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
